/** @returns {string} */
export function generateBlockId() {
  return `blk_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}

/**
 * Ancien format : un seul objet par slot. Nouveau : tableau de blocs.
 * @param {unknown} raw
 * @returns {Array<Record<string, unknown> & { id?: string }>}
 */
export function normalizeSlotBlocks(raw) {
  if (raw == null) return [];
  const arr = Array.isArray(raw) ? raw : [raw];
  return arr
    .filter(Boolean)
    .map((b, i) => ({
      ...b,
      id: b.id || `legacy_${i}_${b.blockType || "x"}_${String(b.sectionId ?? "")}`,
    }));
}

/**
 * Le slot doit être rendu s'il existe au moins un bloc actif.
 * @param {unknown} raw
 */
export function slotHasVisibleBlocks(raw) {
  const blocks = normalizeSlotBlocks(raw);
  return blocks.some(Boolean);
}

/**
 * Met à jour les blocs d’un slot sur une slide (mutation de `slide`).
 * @param {object} slide
 * @param {string} slotId
 * @param {(blocks: object[]) => object[]} updater
 */
export function updateSlideSlotBlocks(slide, slotId, updater) {
  const slots = { ...(slide.slots || {}) };
  const prev = normalizeSlotBlocks(slots[slotId]);
  const next = updater(prev);
  if (!next || next.length === 0) delete slots[slotId];
  else slots[slotId] = next;
  slide.slots = slots;
}
